import UseSetParams from "../../microComponents/tablePages/filter/UseSetParams";
import {useSelector} from "react-redux";
import SearchFilterTable from "../../microComponents/tablePages/filter/SearchFilterTable";
import SelectFilterTable from "../../microComponents/tablePages/filter/SelectFilterTable";
import React, {useState} from "react";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import DateFilterTable from "../../microComponents/tablePages/filter/DateFilterTable";
import {activatedJson} from "../../helper/jsons/activatedJson";
import IconBtn from "../../microComponents/elements/IconBtn";
import {Link} from "react-router-dom";
import {MdOutlineEdit} from "react-icons/md";
import ConfirmSwitch from "../../microComponents/modals/ConfirmSwitch";

const OrderColumn = () => {
    const [handleSetParams] = UseSetParams();
    const [getColumnDateProps,] = DateFilterTable()
    const [getColumnSearchProps] = SearchFilterTable();
    const [getColumnSelectProps] = SelectFilterTable();
    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);


    const filter = useSelector((state) => state.TableRedux.filter);
    const handleGetFilterBranch = () => {

        getFilterBranch(setFilterBranch, setBranchLoading)
    }

    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };
    const columns = [{
        title: 'ردیف', className: "hidden lg:table-cell", dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },
        {
            title: 'شماره حواله',
            dataIndex: 'orderNumber',
            key: 'orderNumber',
            ...getColumnSearchProps('شماره حواله', filter.orderNumber, (res) => {
                funcHandleSetParams([{key: 'orderNumber', value: res}]);
            }, 'orderNumber'),
        },
        {
            title: 'واحد', className: "hidden xs:table-cell",
            dataIndex: 'branch',
            key: 'branch', ...getColumnSelectProps(filter.BranchId, 'BranchId', 'واحد', filterBranch, handleGetFilterBranch, (res) => {
                funcHandleSetParams([{key: 'BranchId', value: res}]);
            }, branchLoading),
        },
        {
            title: 'چک کننده', className: "hidden sm:table-cell",
            dataIndex: 'closedBy',
            key: 'closedBy',
        },

        {
            title: 'ایجاد کننده', className: "hidden sm:table-cell",
            dataIndex: 'createBy',
            key: 'createBy',
        },


        {
            title: ' تاریخ', className: "hidden md:table-cell",
            dataIndex: 'createTime',
            key: 'createTime', ...getColumnDateProps([filter.fromCreate, filter.toCreate], (res) => {

                funcHandleSetParams([{key: 'fromCreate', value: res.from_date}, {
                    key: 'toCreate', value: res.end_date
                }])
            }, 'fromCreate'),
        },


        {
            title: 'مشتری', className: "hidden 2md:table-cell",
            dataIndex: 'customer',
            key: 'customer',

            ...getColumnSearchProps('مشتری', filter.customer, (res) => {
                funcHandleSetParams([{key: 'customer', value: res}]);
            }, 'customer'),

        },
        {
            title: 'مبدا', className: "hidden  lg:table-cell",
            dataIndex: 'from',
            key: 'from',

            ...getColumnSearchProps('مبدا', filter.from, (res) => {
                funcHandleSetParams([{key: 'from', value: res}]);
            }, 'from'),

        },
        {
            title: 'مقصد', className: "hidden  lg:table-cell",
            dataIndex: 'to',
            key: 'to',

            ...getColumnSearchProps('مقصد', filter.to, (res) => {
                funcHandleSetParams([{key: 'to', value: res}]);
            }, 'to'),

        },


        {
            className: 'left-73 cell-fix-left', fixed: 'right',
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status', ...getColumnSelectProps(filter.unitMeasurement, 'status', 'وضعیت', activatedJson, null, (res) => {
                funcHandleSetParams([{key: 'status', value: res}]);
            })
            , render: (item, row) => {
                return <ConfirmSwitch id={row.orderNumber} checkedChildren='باز' unCheckedChildren='بسته'
                                      disabled={!item && 'disabled'}
                                      title='بستن حواله'
                                      address={`Order/close/${row.orderNumber}`} defStatus={item}
                                      des='در صورت بستن حواله امکان تغییرات در حواله وجود ندارد. آیا از بستن حواله اطمینان دارید؟'/>


            }
        },
        {
            fixed: 'right',
            title: 'عملیات',
            dataIndex: 'palletId',
            key: 'palletId',
            render: (x, row) => {
                return <div className="redSwitch">
                    <Link to={`/order/edit/${row.orderNumber}`}><IconBtn color='orangeIconBtn'
                                                                         TooltipText='ویرایش حواله'>
                        <MdOutlineEdit size={20} color='white'/>
                    </IconBtn></Link></div>
            }
        },


    ];
    return [columns];
};

export default OrderColumn;